import {
  Dropdown,
  Menu,
  Avatar,
} from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { userImplement } from '@/config/hooks/user';
import { isInternal } from '@/infrastructure/auth';
import { ConfigTabType } from '@/presentation/pages/setting/app-deliver-config/api';

export const AvatarMenu = () => {
  const { t } = useTranslation();
  const history = useHistory();

  const handleSelect = async (key: string) => {
    if (key === 'myApp') {
      history.push('/workbench/apps');
    } else if (key === 'profile') {
      history.push('/user/profile');
    } else if (key === 'config-manage') {
      history.push(`/config-manage?bar=${ConfigTabType.DEFAULT}`);
    } else {
      // 上报手动退出事件
      await window.aegisGalileo.report('manualExit');
      userImplement.logout();
    }
  };

  const menu = () => (
    <Menu onClick={({ key }) => handleSelect(key)}>
      <Menu.Item key="myApp">
        {t('我的产品')}
      </Menu.Item>
      {isInternal() && <Menu.Item key="profile">
        {t('个人信息')}
      </Menu.Item>}
      <Menu.Item key="logout">
        {t('退出登录')}
      </Menu.Item>
    </Menu>
  );

  return <Dropdown overlay={menu} placement={'bottomRight'}>
    <Avatar style={{ marginBottom: '5px' }} size={28} src={userImplement.getAvatar()} />
  </Dropdown>;
};
